var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createRenderer } from 'fela';
import felaSanitizeCss from './felaSanitizeCssPlugin';
import felaPluginFallbackValue from 'fela-plugin-fallback-value';
import felaPluginPlaceholderPrefixer from 'fela-plugin-placeholder-prefixer';
import felaPluginPrefixer from 'fela-plugin-prefixer';
import rtl from 'fela-plugin-rtl';
var createRendererConfig = function (options) {
    if (options === void 0) { options = {}; }
    return (__assign({ plugins: [
            // is necessary to prevent accidental style typos
            // from breaking ALL the styles on the page
            felaSanitizeCss({
                skip: ['content'],
            }),
            felaPluginPlaceholderPrefixer(),
            felaPluginPrefixer(),
            // Heads up!
            // This is required after fela-plugin-prefixer to resolve the array of fallback values prefixer produces.
            felaPluginFallbackValue()
        ].concat((options.isRtl ? [rtl()] : [])), enhancers: [] }, (options.isRtl ? { selectorPrefix: 'rtl_' } : {})));
};
export var felaRenderer = createRenderer(createRendererConfig());
export var felaRtlRenderer = createRenderer(createRendererConfig({ isRtl: true }));
export default felaRenderer;
